import { createFileRoute } from '@tanstack/react-router';

import { dashboardQueryOptions, homeRevenueTrendParams } from '@/features/dashboard/api';
import { DashboardPage } from '@/features/dashboard/components/dashboard-page';
import { revenueTrendQueryOptions } from '@/features/revenue/api';

export const Route = createFileRoute('/_app/')({
  staticData: { title: '홈' },
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.query({ ...dashboardQueryOptions(), staleTime: 'static' }),
      queryClient.query({
        ...revenueTrendQueryOptions(homeRevenueTrendParams()),
        staleTime: 'static',
      }),
    ]),
  head: () => ({ meta: [{ title: '홈 · 팬즈드롭 파트너' }] }),
  component: DashboardPage,
});
